import { useEffect, useState } from "react";
import { useMuiScreenSizes } from "../../hooks/useMuiScreenSizes";
import { HiQuestionMarkCircle } from "react-icons/hi";
import { FaQuestion } from "react-icons/fa6";

const ZendeskCustomLauncherHandler = () => {
    const { isScreenMedium } = useMuiScreenSizes();
    const [chat, setChat] = useState(process.env.REACT_APP_ZENDESK_ENABLED === "true");

    useEffect(() => {
        const conversationBadge = document.querySelector("#conversation-badge");
        const unreadIndicator = document.querySelector("#unread-indicator");

        const populateUnreadIndicator = (count) => {
            if (!count) return resetUnreadIndicator();

            unreadIndicator.innerHTML = count;
            conversationBadge.setAttribute("class", "tilt-animation");
            unreadIndicator.style.display = "flex";
        };

        const resetUnreadIndicator = () => {
            unreadIndicator.innerHTML = 0;
            conversationBadge.setAttribute("class", "");
            unreadIndicator.style.display = "none";
        };

        // Restore open state on widget ready
        /*
        window.zE('messenger:on', 'ready', () => {
            const wasOpen = localStorage.getItem('zendeskWidgetOpen');
            if (wasOpen === 'true') {
                window.zE('messenger', 'open');
            } else {
                window.zE('messenger', 'close');
            }
        });
        */

        function onZendeskReady(callback) {
            if (typeof window.zE !== "undefined") {
                callback();
            } else {
                const interval = setInterval(() => {
                    if (typeof window.zE !== "undefined") {
                        clearInterval(interval);
                        callback();
                    }
                }, 100);
            }
        }

        onZendeskReady(() => {
            const wasOpen = localStorage.getItem("zendeskWidgetOpen");
            if (wasOpen === "true") {
                window.zE("messenger", "open");
            } else {
                window.zE("messenger", "close");
            }

            // unread Message on listener
            window.zE("messenger:on", "unreadMessages", (count) => {
                populateUnreadIndicator(count);
            });

            // Track open/close state
            window.zE("messenger:on", "open", () => {
                localStorage.setItem("zendeskWidgetOpen", "true");
            });

            window.zE("messenger:on", "close", () => {
                localStorage.setItem("zendeskWidgetOpen", "false");
            });

            conversationBadge.onclick = () => {
                window.zE("messenger", "open");
            };
        });

        // Function to change the target of all links inside the Zendesk iframe
        const modifyLinksInZendeskIframe = () => {
            const iframe = document.querySelector('iframe[title="Messaging window"]');
            if (iframe) {
                const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                if (iframeDoc) {
                    const links = iframeDoc.querySelectorAll("a");
                    let fullUrl = window.location.href;
                    let baseAddress = fullUrl.replace(/^https?:\/\//, "").split("/")[0];

                    links.forEach((link) => {
                        if (String(link).includes(baseAddress)) link.setAttribute("target", "_parent");
                    });
                }
            }
        };

        const intervalId = setInterval(() => {
            modifyLinksInZendeskIframe();
        }, 1000);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    return (
        <div id="conversation-badge" style={{ display: chat ? "" : "none" }}>
            <div className="badge-container">
                {isScreenMedium ? (
                    <FaQuestion stroke="white" strokeWidth={20} size={32} />
                ) : (
                    <HiQuestionMarkCircle size={45} />
                )}
                <div>
                    <span className="badge-text">Need help? Let's chat!</span>
                    <span id="unread-indicator" style={{ display: "none" }}>
                        0
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ZendeskCustomLauncherHandler;
